import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1e2dcd22&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=1e2dcd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2dcd22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2dcd22')) {
      api.createRecord('1e2dcd22', component.options)
    } else {
      api.reload('1e2dcd22', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1e2dcd22&scoped=true&", function () {
      api.rerender('1e2dcd22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/password_reminder/index.vue"
export default component.exports